import cache from "./cache"
import "./echart";

export default {
  install(Vue) {
    // 缓存对象
    Vue.prototype.$cache = cache
  }
}
